import React, { useRef } from 'react';
import ReactTooltip from 'react-tooltip';

export type CaremapprTooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  id?: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
  variant?: 'dark' | 'light';
  delayShow?: number;
  delayHide?: number;
  clickable?: boolean;
  className?: string;
  disabled?: boolean;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
};

const CaremapprTooltip: React.FC<CaremapprTooltipProps> = ({
  children,
  content,
  id,
  place = 'top',
  variant = 'dark',
  delayShow,
  delayHide,
  clickable,
  className,
  disabled,
  wrapperClassName,
  wrapperStyle,
}) => {
  // Stable tooltip id across renders
  const idRef = useRef<string>(
    id || `cmp-tooltip-${Math.random().toString(36).slice(2, 9)}`,
  );
  const tooltipId = idRef.current;

  if (disabled) return <>{children}</>;

  return (
    <>
      {/* Anchor element for the tooltip */}
      <span
        data-for={tooltipId}
        data-tip=""
        className={wrapperClassName}
        style={wrapperStyle}
      >
        {children}
      </span>

      {/* Tooltip content and behavior */}
      <ReactTooltip
        id={tooltipId}
        place={place}
        type={variant}
        delayShow={delayShow}
        delayHide={delayHide}
        clickable={clickable}
        className={className}
      >
        {content}
      </ReactTooltip>
    </>
  );
};

export default CaremapprTooltip;
